// Montant en toutes lettres (français, règles de 1990 : traits d'union partout).
const UNITES = ['zéro', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf', 'dix',
  'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];
const DIZAINES = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante', 'quatre-vingt', 'quatre-vingt'];

function moinsDeCent(n) {
  if (n < 20) return UNITES[n];
  const d = Math.floor(n / 10);
  let u = n % 10;
  if (d === 7 || d === 9) u += 10; // soixante-dix, quatre-vingt-dix…
  if (u === 0) return d === 8 ? 'quatre-vingts' : DIZAINES[d];
  if ((u === 1 || u === 11) && d < 8) return `${DIZAINES[d]}-et-${UNITES[u]}`;
  return `${DIZAINES[d]}-${UNITES[u]}`;
}

function moinsDeMille(n, finale) {
  const c = Math.floor(n / 100);
  const r = n % 100;
  let txt = '';
  if (c > 0) txt = c === 1 ? 'cent' : `${UNITES[c]}-cent${r === 0 && finale ? 's' : ''}`;
  if (r > 0) txt = txt ? `${txt}-${moinsDeCent(r)}` : moinsDeCent(r);
  // « quatre-vingts » ne prend pas de s s'il est suivi de « mille »
  if (!finale) txt = txt.replace(/quatre-vingts$/, 'quatre-vingt');
  return txt;
}

/** 1250500 → « un-million-deux-cent-cinquante-mille-cinq-cents » */
export function nombreEnLettres(nombre) {
  let n = Math.round(Math.abs(Number(nombre) || 0));
  if (n === 0) return 'zéro';
  const parts = [];
  const groupes = [[1e9, 'milliard'], [1e6, 'million'], [1e3, 'mille']];
  for (const [val, nom] of groupes) {
    const q = Math.floor(n / val);
    if (q > 0) {
      if (nom === 'mille') parts.push(q === 1 ? 'mille' : `${moinsDeMille(q, false)}-mille`);
      else parts.push(`${moinsDeMille(q, true)}-${nom}${q > 1 ? 's' : ''}`);
      n %= val;
    }
  }
  if (n > 0) parts.push(moinsDeMille(n, true));
  return parts.join('-');
}

/** « Deux-cent-cinquante-mille francs CFA » */
export function montantEnLettres(montant) {
  const t = nombreEnLettres(montant);
  return `${t.charAt(0).toUpperCase()}${t.slice(1)} francs CFA`;
}
